export default __webpack_public_path__ + "static/media/gallery_26.d8aae179.jpg";